module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetHigh.c958746.webp";